import * as LTE from "#/def/lookup-tables.enums.gen";

/** UL BF – polni dostop v sklopu Drobnica. */
export const DROBNICA_STAFF_ROLES = [
  LTE.SifNivoDostopa.BF,
  LTE.SifNivoDostopa.ADMIN,
  LTE.SifNivoDostopa.TP,
  LTE.SifNivoDostopa.BF_ANALITIK,
  LTE.SifNivoDostopa.RAZVIJALEC,
];

/**
 * Dostop brez rejca: zavihki Dokumenti/Analitika, molža, mlečnost, tehtanje,
 * telesne ocene, kakovostni razred (KGZS selekcionisti/kontrolorji + BF).
 */
export const DROBNICA_NON_BREEDER_ROLES = [
  LTE.SifNivoDostopa.BF,
  LTE.SifNivoDostopa.ADMIN,
  LTE.SifNivoDostopa.KONTROLOR,
  LTE.SifNivoDostopa.SELEKCIONIST,
  LTE.SifNivoDostopa.TP,
  LTE.SifNivoDostopa.BF_ANALITIK,
  LTE.SifNivoDostopa.RAZVIJALEC,
];
